module.exports = __webpack_public_path__ + "img/cellphone-android.855cb77e.svg";